<template>
    <div class="commonTable_fk_box">
        <el-table
        height="100%"
        ref="multipleTable"
        :data="tableData" 
        >
        <el-table-column
            v-for="(val,index) in tableTitle" :key="index"
            :prop="val.prop"
            :label="val.label"
            >
            <template slot-scope="scope">
                <el-image @mouseover="setS1(scope.row[val.prop])" @mouseout="setS2" :preview-src-list="[scope.row[val.prop]]" v-if="val.is_img" style="width:100%"  :src="scope.row[val.prop]+'?x-oss-process=image/resize,w_100'"></el-image>
                <div v-else>
                    <div v-if="val.is_turn">{{val.fun(scope.row[val.prop])}}</div>
                    <el-button v-else-if="val.click_fun && (scope.row.status !=5 && scope.row.status !=4) && scope.row[val.prop]" 
                        @click="val.click_fun(scope.row)" type="text" size="small">
                        {{scope.row[val.prop] || '--'}}
                    </el-button>
                    <div v-else-if="val.set_price_color" :style="scope.row.price_color?{color:scope.row.price_color}:''">{{val.unit?val.unit+scope.row[val.prop]:scope.row[val.prop]}}</div>
                    <div v-else-if="val.is_props">
                        <div v-for="(item,index) in val.props" :key="index">
                            <div v-if="item.is_select">
                                <!-- :class="scope.row[item.prop_name]=='2'?'select_box':(scope.row[item.prop_name]=='0'||scope.row[item.prop_name]=='1')?'select_doc':''" -->
                                <el-select v-if="scope.row.is_edit && scope.row.status=='1'" v-model="scope.row[item.prop_name]" placeholder="请选择"
                                 @change="item.fun(scope.row[item.prop_name],scope.row)">
                                    <el-option
                                    v-for="(da,index) in item.props_val"
                                    :key="index"
                                    :label="da.label"
                                    :value="da.value">
                                    </el-option>
                                </el-select>
                                <div v-else :style="item.text_color?{'color':item.text_color(scope.row[item.text_color_name])}:''">{{item.turn_fun(scope.row[item.prop_name])}}</div>
                            </div>
                            <div v-else>
                                <div v-if="item.turn_fun">
                                    <div v-if="item.is_show_fun?item.is_show_fun(scope.row.status):true"
                                    :style="item.text_color?{'color':item.text_color(scope.row[item.text_color_name])}:''">
                                        {{item.turn_fun(scope.row[item.prop_name])}}
                                    </div>
                                    <div v-else>{{'--'}}</div>
                                </div>
                                <div v-else-if="item.is_show_fun?item.is_show_fun(scope.row.lock_status):''">{{scope.row[item.prop_name]}}</div>
                                <div v-else-if="scope.row.lock_status=='2'||(item.prop_name=='check_admin_name'||item.prop_name=='check_time')">{{scope.row[item.prop_name]||'--'}}</div>
                                <div v-else>{{'--'}}</div>
                            </div>
                            <!-- <div v-if="item.fun">{{item.turn_fun(scope.row[item.prop_name])}}</div>
                            <div v-else>{{scope.row[item.prop_name]}}</div> -->
                        </div>
                    </div>
                    <div v-else-if="val.is_tags && scope.row.is_edit && checkStatus != '-1'">
                        <el-input v-model="scope.row[val.prop]" placeholder="请输入内容" @change="val.fun(scope.row[val.prop],scope.row)"></el-input>
                    </div>
                     <div v-else-if="val.is_weight_input && checkStatus == '4'">
                        <div v-if="activeName=='1'">
                            <el-input v-if="scope.row.is_edit" v-model="scope.row['top_sort']" placeholder="请输入内容" @change="val.fun(scope.row)"
                            :onkeyup="scope.row['top_sort'] = scope.row['top_sort'].match(/\d+(\.\d{0,2})?/) ? scope.row['top_sort'].match(/\d+(\.\d{0,2})?/)[0] : ''"></el-input>
                            <div v-else>{{scope.row['top_sort']}}</div>
                        </div>
                        <div v-else>
                            <el-input v-if="scope.row.is_edit" v-model="scope.row['sort']" placeholder="请输入内容" @change="val.fun(scope.row)"
                            :onkeyup="scope.row['sort'] = scope.row['sort'].match(/\d+(\.\d{0,2})?/) ? scope.row['sort'].match(/\d+(\.\d{0,2})?/)[0] : ''"></el-input>
                            <div v-else>{{scope.row['sort']}}</div>
                        </div>
                    </div>
                    <div v-else-if="val.is_select">
                        <div v-if="scope.row.is_edit">
                            <el-select v-if="val.is_show_fun?val.is_show_fun(scope.row.status):''" 
                                v-model="scope.row[val.prop]" placeholder="请选择" @change="val.fun(scope.row[val.prop],scope.row)">
                                <el-option
                                v-for="(item,index) in val.props"
                                :key="index"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                            <div v-else>{{'--'}}</div>
                        </div>
                        <div v-else>
                            <div v-if="val.is_show_fun?val.is_show_fun(scope.row.status):''">
                                {{val.set_prop(scope.row[val.prop])}}
                            </div>
                            <div v-else>{{'--'}}</div>
                        </div>
                    </div>
                    <div v-else-if="val.is_input && scope.row.is_edit && checkStatus != '-1'">
                        <el-input v-model="scope.row[val.prop]" placeholder="请输入内容" @change="val.fun(scope.row[val.prop],scope.row)"></el-input>
                    </div>
                    <div v-else-if="val.is_picker && (checkStatus == '1'||checkStatus == 'all'||checkStatus == '4')">
                        <div v-if="scope.row.is_edit && val.is_show_fun?val.is_show_fun(scope.row.lock_status):''">
                            <el-date-picker
                            @change="val.fun(scope.row[val.prop],scope.row)"
                            v-model="scope.row[val.prop]"
                            type="datetime"
                            placeholder="选择日期时间">
                            </el-date-picker>
                        </div>
                        <div v-else>
                            <div v-if="val.is_show_fun?val.is_show_fun(scope.row.lock_status):''">
                                {{scope.row[val.prop]||'--'}}
                            </div>
                            <div v-else>{{'--'}}</div>
                        </div>
                    </div>
                    <div v-else>{{val.unit?val.unit+scope.row[val.prop]:scope.row[val.prop] || '--'}}</div>
                </div>
            </template>
        </el-table-column>
        <el-table-column
        v-if="btnList"
        fixed="right"
        label="操作"
        min-width="170px">
        <template name="scope" slot-scope="scope">
            <div class="btnList_box" v-for="(item,index) in btnList" :key="index">
                <el-dropdown v-if="item.is_dropdown && item.is_show_fun?item.is_show_fun(scope.row.status,scope.row.settle):''" 
                 @command="(e)=>item.fun(e,scope.row)">
                    <span class="el-dropdown-link btn_box">
                        {{item.btn}}
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(value,index) in item.dropdown_items" :key="index"
                        :command="value.val">
                            {{value.title}}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-button v-if="!item.is_dropdown" :type="item.btn_type"
                @click="item.fun(scope.row,scope.$index)" size="small"
                v-show="item.is_show_fun?item.is_show_fun(scope.row.status,scope.row.is_edit,scope.row):true"
                class="btn_box">{{item.btn}}
                </el-button>
            </div>
        </template>
        </el-table-column>
        </el-table>
        <CommonTopGo v-if="is_show_top" @backtop="backtop"/>
        <div class="shtion screenContent" v-if="showImg">
            <img style="max-height: 500px;"  :src="showImgSrc"/>
        </div>
    </div>
</template>

<script>
import CommonTopGo from "@/components/common_top/common_top.vue"
import {formatDateTime} from '@/common/utils/util'
export default {
    props:{
        tableData:Array, //表格数据
        tableTitle:Array, //表格表头
        btnList:Array, //表格按钮
        get_status_fun:Function,
        activeName:String,
        checkStatus:String
    },
    data(){
        return{
            select_val:'',
            is_show_top:false,
            showImgSrc:'',
            showImg:false
        }
    },
    components:{
        CommonTopGo
    },  
    mounted(){
        this.$refs.multipleTable.bodyWrapper.addEventListener('scroll', (e) => {
            console.log(e,'eee')
            if(e.target.scrollTop>=500){
                this.is_show_top = true
            }else{
                this.is_show_top = false
            }	
        })
    },
    methods:{
        setS1(u){
            console.log(345)
            if(u.indexOf('?')){
                this.showImgSrc = u.split('?')[0];
            }else{
                this.showImgSrc = u
            }
            this.showImg = true;
        },
        setS2(){
            this.showImgSrc = '';
            this.showImg = false;
        },
        backtop(){
            this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
        },
        //格式化日期：可自定义日期格式
        dateFormat(fmt, date) {
            let ret;
            const opt = {
                "Y+": date.getFullYear().toString(),        // 年
                "m+": (date.getMonth() + 1).toString(),     // 月
                "d+": date.getDate().toString(),            // 日
                "H+": date.getHours().toString(),           // 时
                "M+": date.getMinutes().toString(),         // 分
                "S+": date.getSeconds().toString()          // 秒
                // 有其他格式化字符需求可以继续添加，必须转化成字符串
            };
            for (let k in opt) {
                ret = new RegExp("(" + k + ")").exec(fmt);
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                };
            };
            return fmt;
        },
        get_status(val) {
            return this.get_status_fun(val)
        },
        isImg(url) {
           if(!/\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(url)){
               return false
           }else if(url.indexOf('gif'||'jpg'||'jpeg'||'png'||'GIF'||'JPG'||'PNG')===-1){
               return false
           }
           else{
               return true
           }
        },
        handleClick(e){
            //console.log(e)
        }
    }
}
</script>

<style lang="scss" scoped>
.commonTable_fk_box{
    height: 100%;
    .ul_box{
        display: flex;
        .li_box{
            box-sizing:border-box !important;
            display: flex;
            flex: 1;
            padding: 11px;
        }
        .last_li_box{
            box-sizing:border-box !important;
            width: 300px !important;
        }
    }
    .select_box{
        margin-top: 45px !important;
    }
    .select_doc{
         margin-top: 24px !important;
    }
    .shtion{
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left:0;

		pointer-events: none;
	}
}
</style>

<style lang="scss">
.commonTable_fk_box{
    tr{
        th{
            .cell{
                color: #333;
                font-size: 14px!important;
            }
        }
    }
    td{
        .cell{
            display: flex;
            .btnList_box{
                display: flex;
                align-items: center;
                .btn_box{
                    margin: 0 10px;
                }
            }
        }
    }
}
</style>
